import { Component, DoCheck, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, DoCheck {
  showLink: boolean;
  constructor(public router: Router, private authService: AuthService) {}

  email: string;
  ngOnInit(): void {}
  ngDoCheck(): void {
    this.email = this.authService.getAuthData()
      ? this.authService.getAuthData().result.email
      : '';
  }

  navigate(path): void {
    this.router.navigate([`${path}`]);
    this.showLink = false;
  }

  logout(): void {
    this.authService.setAuthData(null);
    this.router.navigate(['/auth']);
  }

  toggle(): void {
    this.showLink = !this.showLink;
  }
}
